module.exports = __webpack_public_path__ + "static/PrintManagement-c5deeea7451b85c9e67facb2f9fdf729.svg";